
import { Observable, Subject } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Usuario } from 'src/app/auth/entidad/usuario';



const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};



@Injectable({
    providedIn: 'root'
  })
  export class LoginService {
    private url : string = `${environment.HOST}/api/auth/`;


    constructor(
        private http : HttpClient,
        private router : Router
      ) { }

     


      login(usuario: string, password: string): Observable<any> {
        return this.http.post(this.url + 'signin', {
          usuario,
          password
        }, httpOptions);
      }
    
    
    
    }
  